import React, {FC} from "react";
import {Alert, Button, Card, Carousel, Container} from "react-bootstrap";
import Image from "react-bootstrap/Image";
import {Link} from "react-router-dom";
import BackgroundBlack from "../Components/BackgroundBlack";

// Bilder Fahrtenbuch
import account from "../Images/Fahrtenbuch/account.jpg";
import angemeldet from "../Images/Fahrtenbuch/angemeldet.jpg";
import start from "../Images/Fahrtenbuch/start.jpg";

// Bilder Abfrageterminal
import startbildschirm from "../Images/Abfrageterminal/startbildschirm.jpg";
import negativ from "../Images/Abfrageterminal/abfrage-negativ.jpg";
import positiv from "../Images/Abfrageterminal/abfrage-positiv.jpg";
import warnung from "../Images/Abfrageterminal/abfrage-warnung.jpg"

//Bilder Homapega
import projekte from "../Images/Homepage/Projekte.jpg"
import startseite from "../Images/Homepage/Startseite.jpg"


const Projects : FC = () => {
    return(
        <>
            <BackgroundBlack>
                <Container className="container-sm d-flex flex-column justify-content-center align-items-center text-center p-3">
                    <h1 className="mb-3 text-white">Projekte</h1>

                    {/*Abfrage Terminal*/}
                    <Card className="text-center" style={{backgroundColor: "transparent", color: "white", maxWidth: "600px"}}>
                        <Card.Body>
                            <Alert style={{backgroundColor: "black", color: "white", border: "1px solid white"}}>
                                <Alert.Heading>Abfrage Terminal</Alert.Heading>
                            </Alert>
                            <Carousel>
                                <Carousel.Item>
                                    <Image src={startbildschirm} alt="Start Screen" fluid/>
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image src={positiv} alt="Positive Outcome" fluid/>
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image src={warnung} alt="Warning Message" fluid/>
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image src={negativ} alt="Negative Outcome" fluid/>
                                </Carousel.Item>
                            </Carousel>
                            <Card.Text>
                                Implementierung einer Software für ein Terminal zur Abfrage von Arbeitszeiten und Informationen
                                zur anstehenden Schicht mit Hilfe von NFC-Technologie für das Fusion-Festival
                            </Card.Text>
                            <Link to={"https://github.com/labpa/Abfrage-KuKo"}>
                                <Button style={{
                                    width: '350px',
                                    backgroundColor: "black",
                                    border: "1px solid white",
                                    color: "#39868e"
                                }}>GitHub Abfrage Terminal</Button>
                            </Link>
                        </Card.Body>
                    </Card>

                    {/*Fahrtenbuch*/}
                    <Card className="text-center" style={{backgroundColor: "transparent", color: "white", maxWidth: "600px"}}>
                        <Card.Body>
                            <Alert style={{backgroundColor: "black", color: "white", border: "1px solid white"}}>
                                <Alert.Heading>Fahrtenbuch</Alert.Heading>
                            </Alert>
                            <Carousel>
                                <Carousel.Item>
                                    <Image src={start} alt="Start Screen" fluid/>
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image src={angemeldet} alt="Positive Outcome" fluid/>
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image src={account} alt="Warning Message" fluid/>
                                </Carousel.Item>
                            </Carousel>
                            <Card.Text>
                                Fartenbuch für den Kulturkosmos Müritz e.V, erstellt mit React und Typescript. Übungsprojekt
                                während der Ausbildung.
                            </Card.Text>
                            <Link to={"https://github.com/labpa/Fahrtenbuch-KuKo.git"}>
                                <Button style={{
                                    width: '350px',
                                    backgroundColor: "black",
                                    border: "1px solid white",
                                    color: "#39868e"
                                }}>GitHub Fahrtenbuch</Button>
                            </Link>
                        </Card.Body>
                    </Card>

                    {/*Homepage*/}
                    <Card className="text-center" style={{backgroundColor: "transparent", color: "white", maxWidth: "600px"}}>
                        <Card.Body>
                            <Alert style={{backgroundColor: "black", color: "white", border: "1px solid white"}}>
                                <Alert.Heading>Homepage</Alert.Heading>
                            </Alert>
                            <Carousel>
                                <Carousel.Item>
                                    <Image src={projekte} alt="Start Screen" fluid/>
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image src={startseite} alt="Positive Outcome" fluid/>
                                </Carousel.Item>
                            </Carousel>
                            <Card.Text>
                                Homepage mit Lebenslauf und Übersicht aktueller Projekte.
                            </Card.Text>
                            <Link to={"https://github.com/labpa/labpa.github.io"}>
                                <Button style={{
                                    width: '350px',
                                    backgroundColor: "black",
                                    border: "1px solid white",
                                    color: "#39868e"
                                }}>GitHub Homepage</Button>
                            </Link>
                        </Card.Body>
                    </Card>

                </Container>
            </BackgroundBlack>
        </>

    )
}

export default Projects

